const features = [
  {
    title: '全网最快爆料速度',
    desc: '7×24小时全天候监控各大赛事动态，编辑团队实时响应，让你比别人更快一步掌握最新内幕消息。',
    icon: 'ri-flashlight-line',
    color: 'primary',
  },
  {
    title: '严格信息核实',
    desc: '每条爆料均经过多方交叉验证，未证实消息明确标注，在速度与真实性之间找到最佳平衡。',
    icon: 'ri-shield-check-line',
    color: 'accent',
  },
  {
    title: '爆料人隐私保护',
    desc: '采用多层加密技术保护投稿人信息，绝不向第三方透露爆料来源，让你安心分享独家消息。',
    icon: 'ri-lock-line',
    color: 'primary',
  },
  {
    title: '全方位赛事覆盖',
    desc: '从电竞、体育到综艺、音乐，覆盖50+热门赛事类型，一个平台满足你所有吃瓜需求。',
    icon: 'ri-global-line',
    color: 'accent',
  },
];

export default function Features() {
  return (
    <section id="features" className="section-py bg-background-100">
      <div className="section-container">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            平台优势
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-6 text-center hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-full mx-auto mb-4 ${
                item.color === 'primary' ? 'bg-primary-50 text-primary-600' : 'bg-accent-50 text-accent-600'
              }`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading">{item.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}